<h1 mat-dialog-title class="col-12 userProfileTitle">{{data.dialogTitle}}</h1>

<mat-form-field class="col-6">
  <input matInput [(ngModel)]="data.user.firstName" placeholder="First Name">
</mat-form-field>

<mat-form-field class="col-6">
  <input matInput [(ngModel)]="data.user.lastName" placeholder="Last Name">
</mat-form-field>

<mat-form-field class="col-12">
  <input matInput [(ngModel)]="data.user.orgName" placeholder="Organization Name">
</mat-form-field>

<mat-form-field class="col-12">
  <input matInput [(ngModel)]="data.user.email" placeholder="Email" disabled>
</mat-form-field>

<div class="col-12 mb-3">
  <mat-dialog-actions align="end">
    <button mat-raised-button (click)="onClickCancel()" class="userProfileCancelButton">Cancel</button>
    <button mat-raised-button color="primary" (click)="onClickSave()" cdkFocusInitial class="userProfileSaveButton">Save</button>
  </mat-dialog-actions>
</div>
